"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDBConfig = exports.getDefaultTypeOfDB = void 0;
exports.getDefaultTypeOfDB = {
    mongo() {
        // mongo 不需要数据库类型
        return {};
    },
    mysql(schema) {
        var _a;
        switch (schema.type) {
            case "integer":
                return { type: "INT" };
            case "number":
                return { type: "DECIMAL" }; // 不使用 FLOAT 或者 DOUBLE。 https://git.code.oa.com/standards/sql
            case "null":
                return { type: "NULL" };
            case "string":
                const maxLength = (_a = schema.validation) === null || _a === void 0 ? void 0 : _a.maxLength;
                if (!maxLength || maxLength > 5000)
                    return { type: "TEXT" };
                return { type: "VARCHAR", length: maxLength };
            // TODO: datetime
            // case "datetime":
            //   return { type: "DATETIME" }
        }
        return {};
    }
};
/**
 * 获取 schema 的 DB 配置，如果 `type` 没设置，会自动生成默认值。
 *
 * 注意：对于 object、array、null 等情况，返回的 type 仍然可能是空的！
 */
function getDBConfig(schema, opts) {
    var _a;
    if ((_a = schema === null || schema === void 0 ? void 0 : schema.db) === null || _a === void 0 ? void 0 : _a.type)
        return schema.db;
    const getDefaultType = exports.getDefaultTypeOfDB[opts.family] || exports.getDefaultTypeOfDB.mongo;
    const ans = Object.assign(Object.assign({}, getDefaultType(schema)), (schema === null || schema === void 0 ? void 0 : schema.db) || {});
    return ans;
}
exports.getDBConfig = getDBConfig;
//# sourceMappingURL=db.js.map